<div>
    <dx-button
      class="theme-button"
      stylingMode="text"
      [icon]="'fas fa-horse'"
      (onClick)="onButtonClick()"
      hint="Open Patricia"
    />
</div>